













import { EMBED_SCRIPT_ID } from '@/api/EventConstants';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class DonationEmbed extends Vue {
  @Prop(String) public readonly embedId!: string;
  @Prop(String) public readonly eventId!: string;
  @Prop(String) public readonly embedType!: string;


  private mounted() {
    if (this.embedType === 'giving_form') {
      // Script injection for 2.0 forms moved into the mounted() method of
      // this component due to how 2.0 initializes forms on DOM load.
      // Legacy forms has a dedicated init method, and adding one to 2.0 loader
      // added complexity in how to indicate if it was an async load or not.
      const scriptUrl = this.$store.getters.embed.givingFormScriptUrl;
      if (document.getElementById(EMBED_SCRIPT_ID) === null) {
        const embedScript = document.createElement('script');
        embedScript.setAttribute(
          'src',
          scriptUrl,
        );
        embedScript.setAttribute('id', EMBED_SCRIPT_ID);
        document.head.appendChild(embedScript);
      }
    } else {
      // call initializeEmbeds from legacy idonate.js to populate data-idonate-embed tags.
      (window as any).initializeEmbeds();
    }
  }
}
